import Head from 'next/head';

import { applicationSettings } from '@/constants';
import CitiesList from '@/components/CitiesList';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import StateHero from '@/components/StateHero';
// import Testimonials from '@/components/Testimonials'
import { STATES } from '@/data/states';

const { CALLAPRO_WEBSITE_URL } = applicationSettings;

export async function getStaticPaths() {
  const paths = Object.values(STATES).map((state) => ({
    params: {
      state: state.abbreviation.toLowerCase()
    }
  }));

  return { paths, fallback: false };
}

export async function getStaticProps({ params }) {
  const state = STATES[params.state.toUpperCase()];

  return {
    props: {
      state
    }
  };
}

const Category = (props) => {
  const { state } = props;
  const { label, abbreviation } = state;

  return (
    <div className="page-wrapper">
      <Head>
        <meta name="description" content={`CallAPro - Find a Home Service Professional in ${label}`} />
        <title>Search Home Service Professionals in {label}</title>
        <link rel="canonical" href={`${CALLAPRO_WEBSITE_URL}/us/${abbreviation.toLowerCase()}/`} />
      </Head>
      <Header />
      <StateHero {...props} />
      <CitiesList {...props} />
      {/*<Testimonials />*/}
      <Footer />
    </div>
  );
};

export default Category;
